import { Injectable } from '@angular/core'
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router'

import { Observable } from 'rxjs/Rx'

import { Cookie } from 'ng2-cookies/ng2-cookies'

import { AuthenticationService } from '../../services'
import { AuthenticationError } from '../../models'
import { MergedExceptionHandler, AuthenticationExceptionHandler } from '../../helpers'

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private _authService: AuthenticationService,
    private _exceptionHandler: MergedExceptionHandler
  ) {}

  public canActivate(
    // Not using but worth knowing about
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const jwtSecret = Cookie.get('MP-AUTH-TOKEN')
    if (typeof jwtSecret === 'undefined' || jwtSecret === null) {
      const authExceptionHandler = this._exceptionHandler.getHandlerInstance(AuthenticationExceptionHandler)
      authExceptionHandler.handleError('No JWT cookie found')
      return Observable.of(false)
    }

    return this._authService.authenticateWithToken(jwtSecret)
  }

  public canActivateChild(
    // Not using but worth knowing about
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/guards/auth-guard/auth.guard.ts